import React, { useState } from 'react';
import api from '../utils/api';

// Ссылки в тексте пункта — кликабельные: на телефоне длинный адрес переносится по дефису и при выделении обрезается.
const linkify = text => String(text).split(/(https?:\/\/[^\s<>«»"]+)/g).map((part, i) => (i % 2
  ? <a key={i} href={part} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)', wordBreak: 'break-all' }}>{part}</a>
  : part));

// Пункты задачи с галочками. task.checklist = [{text, done}]. onChange(updatedTask) — обновить задачу в списке.
export default function TaskChecklist({ task, onChange, compact }) {
  const [items, setItems] = useState(Array.isArray(task.checklist) ? task.checklist : []);
  const [adding, setAdding] = useState(false);
  const [draft, setDraft] = useState('');
  const [open, setOpen] = useState(false);

  const save = async (next) => {
    setItems(next);
    try {
      const { data } = await api.patch(`/tasks/${task.id}/checklist`, { checklist: next });
      if (onChange) onChange(data);
    } catch { setItems(items); }
  };
  const stop = e => e.stopPropagation();
  const toggle = i => save(items.map((x, k) => (k === i ? { ...x, done: !x.done } : x)));
  const remove = i => save(items.filter((_, k) => k !== i));
  const add = () => { const v = draft.trim(); if (!v) return; save([...items, { text: v, done: false }]); setDraft(''); };

  const doneCount = items.filter(x => x.done).length;
  const fs = compact ? 12 : 13;
  return (
    <div onClick={stop} style={{ margin: '4px 0 6px' }}>
      {items.length > 0 && (
        <button onClick={() => setOpen(v => !v)} title={open ? 'Свернуть пункты' : 'Показать пункты'}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12, padding: '2px 8px', marginBottom: 4, borderRadius: 6,
            border: '1px solid var(--border)', background: 'var(--bg-hover)', color: doneCount === items.length ? 'var(--green, #10b981)' : 'var(--text)', cursor: 'pointer' }}>
          <span style={{ display: 'inline-block', transform: open ? 'rotate(90deg)' : 'none', transition: 'transform .15s' }}>▸</span>
          Пункты: {doneCount} из {items.length}
          <span style={{ display: 'inline-block', width: 50, height: 5, borderRadius: 3, background: 'var(--border)', overflow: 'hidden' }}>
            <span style={{ display: 'block', height: '100%', width: `${Math.round(doneCount / items.length * 100)}%`, background: 'var(--green, #10b981)' }} />
          </span>
        </button>
      )}
      {items.length > 0 && open && (
        <div style={{ borderLeft: '2px solid var(--border)', paddingLeft: 10, marginBottom: 4 }}>
          {items.map((x, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '2px 0' }} className="task-check-row">
              <input type="checkbox" checked={x.done} onChange={() => toggle(i)} style={{ width: 15, height: 15, marginTop: 2, cursor: 'pointer', flexShrink: 0 }} />
              <span style={{ flex: 1, fontSize: fs, textDecoration: x.done ? 'line-through' : 'none', color: x.done ? 'var(--text-muted)' : 'var(--text)' }}>{linkify(x.text)}</span>
              <button onClick={() => remove(i)} title="Удалить пункт"
                style={{ border: 'none', background: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: 14, lineHeight: 1, padding: '0 2px' }}>×</button>
            </div>
          ))}
        </div>
      )}
      {adding ? (
        <div style={{ display: 'flex', gap: 6 }}>
          <input autoFocus value={draft} onChange={e => setDraft(e.target.value)} placeholder="Новый пункт"
            onKeyDown={e => { if (e.key === 'Enter') add(); if (e.key === 'Escape') { setAdding(false); setDraft(''); } }}
            style={{ flex: 1, fontSize: 13, padding: '4px 8px', borderRadius: 6, border: '1px solid var(--border)', background: 'var(--bg-input)', color: 'var(--text)' }} />
          <button onClick={add} style={{ fontSize: 12, padding: '4px 10px', borderRadius: 6, border: 'none', background: 'var(--accent)', color: '#fff', cursor: 'pointer' }}>Добавить</button>
          <button onClick={() => { setAdding(false); setDraft(''); }} style={{ fontSize: 12, padding: '4px 8px', borderRadius: 6, border: '1px solid var(--border)', background: 'var(--bg-hover)', color: 'var(--text)', cursor: 'pointer' }}>×</button>
        </div>
      ) : (
        !task.done && (open || items.length === 0) && <button onClick={() => setAdding(true)}
          style={{ fontSize: 11, padding: '1px 6px', borderRadius: 6, border: '1px dashed var(--border)', background: 'none', color: 'var(--text-muted)', cursor: 'pointer' }}>+ пункт</button>
      )}
    </div>
  );
}
